var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v("恭喜获得"+_vm._s(_vm.videoSubjectName.toString())+"学科专属视频解析服务，快去学习吧~填写地址后，我们会尽快为您邮寄真题实战图书哟。")]),_c('div',{staticClass:"btn",on:{"click":_vm.goStudy}},[_vm._v("去学习")]),_c('img',{attrs:{"src":"https://iqh-zt-pord-cdn.iqihang.com/%E5%BD%A2%E7%8A%B6%402x.png"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }